/* file description */
import { useRef, useState } from 'react';
// import { compose } from '@cui/corteza-js';
import { getRecordModuleByRequest } from '@/common/asset-apis/getRecordModuleByRequest';
import { composeRecord } from '@/utils';

import type { UseXMRequestProp } from './type';

export const useRequestProp: UseXMRequestProp = ({
  namespaceID,
  moduleID,
  FetchAPI,
  initData,
  moduleInfo,
  recordValues,
}) => {
  const dataSourceRef = useRef<Array<Record<string, any>>>([]);
  const [formInitData, setFormInitData] = useState<Record<any, any>>({});
  return {
    currentTableDataSource: dataSourceRef.current,
    formInitData,
    mergeRequest: async ({ recordID, modelDefaultValues }) => {
      // const module = moduleInfo.clone();
      const module = moduleInfo;
      if (!recordID || recordID === '0') {
        setFormInitData({
          value: { ...modelDefaultValues, ...initData },
          isRender: true,
        });
        return {
          // ...new compose.Record(module, {}).values,
          ...modelDefaultValues,
          ...initData,
        };
      }

      let result = recordValues;
      if (!recordValues) {
        result = await getRecordModuleByRequest({
          FetchAPI,
          namespaceID,
          moduleID,
          recordID,
        });
      }
      const records = composeRecord(result);
      dataSourceRef.current = [records] || [];
      setFormInitData({
        value: records,
        isRender: true,
      });
      return records;
    },
  };
};
